import React from "react";
import "./AdditionalPanel.css";
import { MdClose } from "react-icons/md";
import TopologicalAnalysis from "../../TopologicalAnalysis/TopologicalAnalysis";
import BasemapPanel from "../../Panels/Basemap/BasemapPanel";
import MeaurementPanel from "../../Panels/Measurement/MeasurementPanel";
import DrawingPanel from "../../Drawing/DrawingPanel";
import ChartPanel from "../../Charts/ChartPanel/ChartPanel";
import PrintPanel from "../../Panels/Print/PrintPanel";
import AddLayerSidebar from "../../Panels/Add/AddLayerSidebar";
import CompareLayersSidebar from "../../Compare/CompareLayersSidebar";
import LayerPanel from "../../Panels/Layers/LayerPanel";
import LayerFilterPanel from "../../Panels/Filter/LayerFilterPanel";

function AdditionalPanel({
    wfsLayers,
    wmsLayers,
    activePanel,
    setInputUrl,
    addLayerFromCatalog,
    handleLayerSubmit,
    handleWmsLayerSubmit,
    handleLoadGML,
    handleLoadKML,
    handleLoadGeoJson,
    handleLoadDXF,
    handleLoadShapefile,
    handleLoadLasFile,
    onClose,
    setWfsLayers,
    setHoverInfo,
    handleDestroyMeasurement,
    measurementResult,
    handleClickInfo,
    setWmsLayers,
    handleMapStyleChange,
    lasLayers,
    setLasLayers,
    viewState,
    setViewState,
    setLayerInfo,
    handlePrint,
    mapRef,
    deckRef,
    selectedFeature,
    setActiveMode,
    activeMode,
    setCheckedLayers,
    handleToggleCompare,
    isCompareMode,
    setOverlay,
    id_terenske_jedinice,
    userInfo,
    activeLayerFilters,
    setActiveLayerFilters,
}) {
    React.useEffect(() => {
        if (activePanel === "Crtanje") {
            setWfsLayers([]);
            setWmsLayers([]);
        }
    }, [activePanel, setWfsLayers, setWmsLayers]);

    const renderContent = () => {
        switch (activePanel) {
            case "Dodavanje":
                return (
                    <AddLayerSidebar
                        setInputUrl={setInputUrl}
                        handleLayerSubmit={handleLayerSubmit}
                        handleWmsLayerSubmit={handleWmsLayerSubmit}
                        handleLoadGML={handleLoadGML}
                        handleLoadKML={handleLoadKML}
                        handleLoadGeoJson={handleLoadGeoJson}
                        handleLoadDXF={handleLoadDXF}
                        handleLoadShapefile={handleLoadShapefile}
                        handleLoadLasFile={handleLoadLasFile}
                        addLayerFromCatalog={addLayerFromCatalog}
                        viewState={viewState}
                        setOverlay={setOverlay}
                        setWfsLayers={setWfsLayers}
                        setHoverInfo={setHoverInfo}
                        setViewState={setViewState}
                    />
                );

            case "Slojevi":
                return (
                    <LayerPanel
                        wfsLayers={wfsLayers}
                        wmsLayers={wmsLayers}
                        lasLayers={lasLayers}
                        setWfsLayers={setWfsLayers}
                        setWmsLayers={setWmsLayers}
                        setLasLayers={setLasLayers}
                    />
                );

            case "Filter":
                return (
                    <LayerFilterPanel
                        wfsLayers={wfsLayers}
                        wmsLayers={wmsLayers}
                        setHoverInfo={setHoverInfo}
                        handleClickInfo={handleClickInfo}
                        setWfsLayers={setWfsLayers}
                        setWmsLayers={setWmsLayers}
                        viewState={viewState}
                        setViewState={setViewState}
                        setOverlay={setOverlay}
                        id_terenske_jedinice={id_terenske_jedinice}
                        activeFilters={activeLayerFilters}
                        setActiveFilters={setActiveLayerFilters}
                    />
                );

            case "Bazni stilovi":
                return <BasemapPanel handleMapStyleChange={handleMapStyleChange} />;

            case "Alati za mjerenje":
                return (
                    <MeaurementPanel
                        setActiveMode={setActiveMode}
                        handleDestroyMeasurement={handleDestroyMeasurement}
                        measurementResult={measurementResult}
                    />
                );

            case "Štampanje":
                return (
                    <PrintPanel
                        handlePrint={handlePrint}
                        selectedFeature={selectedFeature}
                        setViewState={setViewState}
                        setActiveMode={setActiveMode}
                        activeMode={activeMode}
                        userInfo={userInfo}
                        mapRef={mapRef}
                    />
                );

            case "Dijagram":
                return <ChartPanel wfsLayers={wfsLayers} />;

            case "Poređenje slojeva":
                return (
                    <CompareLayersSidebar
                        wfsLayers={wfsLayers}
                        setCheck={setCheckedLayers}
                        handleToggleCompare={handleToggleCompare}
                        isCompareMode={isCompareMode}
                    />
                );

            case "Crtanje":
                return (
                    <DrawingPanel
                        setWfsLayers={setWfsLayers}
                        setHoverInfo={setHoverInfo}
                        handleClickInfo={handleClickInfo}
                        setWmsLayers={setWmsLayers}
                        viewState={viewState}
                        setViewState={setViewState}
                        setLayerInfo={setLayerInfo}
                        setOverlay={setOverlay}
                        id_terenske_jedinice={id_terenske_jedinice}
                    />
                );

            default:
                return <div>Izaberite opciju iz levog sidebar-a</div>;
        }
    };

    return (
        <div className="additional-panel">
            <div className="panel-header">
                <h2>{activePanel}</h2>
                <MdClose className="close-icons" onClick={onClose} />
            </div>
            <div className="panel-content">
                {renderContent()}
            </div>
        </div>
    );
}

export default AdditionalPanel;